import { defineComponent, computed } from "vue";
import { V as VaIcon } from "../../va-icon/index-7fefcddb.mjs";
import { V as VaCheckbox } from "../../va-checkbox/index-9272786f.mjs";
import { u as useStylableProps, a as useStylable } from "../hooks/useStylable-00990076.mjs";
import { u as useTranslation } from "../../../composables/useTranslation-67b81a6e.mjs";
const _sfc_main = defineComponent({
  name: "VaDataTableThRow",
  components: { VaIcon, VaCheckbox },
  props: {
    ...useStylableProps,
    selectMode: { type: String, default: "multiple" },
    allRowsSelected: { type: Boolean, default: false },
    severalRowsSelected: { type: Boolean, default: false },
    columns: { type: Array, required: true },
    isFooter: { type: Boolean, default: false },
    sortBySync: { type: String, required: true },
    sortingOrderIconName: { type: String, required: true },
    sortingOrderSync: { type: String, default: null },
    ariaSelectAllRowsLabel: { type: String, default: "$t:selectAllRows" },
    ariaSortColumnByLabel: { type: String, default: "$t:sortColumnBy" }
  },
  emits: [
    "toggleBulkSelection",
    "toggleSorting"
  ],
  setup(props, { emit }) {
    const { t, tp } = useTranslation();
    const {
      getFooterCSSVariables,
      getHeaderCSSVariables,
      getClass,
      getStyle
    } = useStylable(props);
    const getAriaAttributes = (column) => {
      const ariaSort = props.sortingOrderSync && props.sortBySync === column.name ? props.sortingOrderSync === "asc" ? "ascending" : "descending" : "none";
      const ariaLabel = column.sortable ? tp(props.ariaSortColumnByLabel, { name: column.label }) : void 0;
      return {
        "aria-sort": ariaSort,
        "aria-label": ariaLabel
      };
    };
    const sortByColumn = (column) => {
      if (props.isFooter && !props.allowFooterSorting || !column.sortable) {
        return;
      }
      emit("toggleSorting", column);
    };
    const toggleBulkSelection = () => emit("toggleBulkSelection");
    const getColumnStyles = (column) => {
      return [props.isFooter ? getFooterCSSVariables(column) : getHeaderCSSVariables(column), getStyle(column.thStyle)];
    };
    const slotNameComputed = computed(() => props.isFooter ? "footer" : "header");
    const multiplySelectAvailable = computed(() => props.selectMode === "multiple");
    return {
      tp,
      getClass,
      sortByColumn,
      getColumnStyles,
      slotNameComputed,
      getAriaAttributes,
      toggleBulkSelection,
      multiplySelectAvailable
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaDataTableThRow.vue_vue_type_script_lang-e266207d.mjs.map
